import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const saveFilter = async ({ filter, name, type }) => {
  await request.post(
    '/Filter',
    {
      filter,
      name,
      colorId: 0,
      iconId: 0,
      position: 0,
      type,
    },
    'Не удалось сохранить фильтр'
  );
};

const useSaveFilterMutation = (options) =>
  useMutation(
    ({ filter, name, type }) => saveFilter({ filter, name, type }),
    options
  );

export default useSaveFilterMutation;
